import { ReactNode } from 'react';
import { Spinner } from '@iwoca/orion';
import { Trans } from '@lingui/react/macro';
import clsx from 'clsx';
import { CopyButton } from 'components/CopyableText/CopyButton/CopyButton';
import styles from './SideNavigationDetail.module.css';

type TProps = {
  value?: string;
  label?: string;
  actionButton?: ReactNode;
  isLoading?: boolean;
  spinnerTestId?: string;
  className?: string;
  valueClassName?: string;
};

export const SideNavigationDetail = ({
  value,
  label,
  actionButton,
  isLoading = false,
  spinnerTestId,
  className,
  valueClassName,
}: TProps) => {
  return (
    <div className={clsx(styles.sideNavigationDetail, className)}>
      <div className={styles.content}>
        {label && <h3 className={styles.label}>{label}</h3>}
        {isLoading ? (
          <Spinner dataTestId={spinnerTestId} />
        ) : value ? (
          <p className={clsx(styles.value, valueClassName)}>{value}</p>
        ) : (
          <p className={styles.valueBlank}>
            <Trans>(Blank)</Trans>
          </p>
        )}
      </div>

      {!isLoading && value && (
        <div className={styles.action}>
          {actionButton || (
            <CopyButton buttonClassName={styles.copyButton} text={value} />
          )}
        </div>
      )}
    </div>
  );
};
